import { render, staticRenderFns } from "./videos.vue?vue&type=template&id=98475d76&scoped=true"
import script from "./videos.vue?vue&type=script&lang=js"
export * from "./videos.vue?vue&type=script&lang=js"
import style0 from "./videos.vue?vue&type=style&index=0&id=98475d76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98475d76",
  null
  
)

export default component.exports